import React, { useState, useContext, useEffect } from "react";
import UserService from "../services/UserService";
import { AuthContext } from "../context/AuthContext";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ConfirmDialog from "./ConfirmDialog";
import AdminService from "../services/AdminService";
import getUserFriendlyMessages from "../genericFunctions/getUserFriendlyMessages";
import { UPDATED } from "../genericFunctions/operationTypeConstants";
import AdminChangePassword from "./AdminChangePassword";

const UserItem = (props) => {
  const [role, setRole] = useState({
    _id: null,
    role: "",
    manager: "",
    availibility: false,
    active: true,
  });
  const [changed, setChanged] = useState(false);
  const [isConfirmSelect, setIsConfirmSelect] = useState(false);
  const [selRole, setSelRole] = useState("");
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isPwdChangeOpen, setIsPwdChangeOpen] = useState(false);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    setRole({
      _id: props.userItem._id,
      role: props.userItem.role,
      manager: props.userItem.manager || "",
      availibility: props.userItem.availible,
      active: props.userItem.active,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const updateUser = () => {
    AdminService.updateRole(role).then((data) => {
      const { message } = data;
      setChanged(false);
      if (!message.msgError) {
        UserService.getUsers().then((data) => {
          props.setUsers(data.users);
          props.setMessage(getUserFriendlyMessages(UPDATED, "user role"));
        });
      } else if (message.msgBody === "Unauthorized") {
        props.setMessage(message);
        authContext.setUser({ username: "", role: "" });
        authContext.setIsAuthenticated(false);
      } else {
        props.setMessage(message);
      }
    });
  };

  const onChange = (e) => {
    setRole({ ...role, [e.target.name]: e.target.value });
    setChanged(true);
  };

  const toggleConfirm = () => {
    setIsConfirmOpen(!isConfirmOpen);
  };

  const deleteConfirmedByUser = () => {
    toggleConfirm();
    props.deleteUser(props.userItem);
  };

  const toggleSelectConfirm = () => {
    setIsConfirmSelect(!isConfirmSelect);
  };

  const openSelect = (e) => {
    setSelRole(e.target.value);
    toggleSelectConfirm();
  };

  const confirmSelect = () => {
    if (selRole === props.userItem.role) {
      setRole({ ...role, role: props.userItem.role });
      setChanged(false);
    } else {
      setRole({ ...role, role: selRole });
      setChanged(true);
    }
    toggleSelectConfirm();
  };

  const togglePwdChange = () => {
    setIsPwdChangeOpen(!isPwdChangeOpen);
  };

  const submitChangePassword = (e, userId, username, newPassword) => {
    setIsPwdChangeOpen(false);
    AdminService.changeUserPassword(userId, newPassword).then((data) => {
      const { message } = data;
      if (!message.msgError) {
        props.setMessage(
          getUserFriendlyMessages(UPDATED, "password for " + username)
        );
      } else if (message.msgBody === "Unauthorized") {
        props.setMessage(message);
        authContext.setUser({ username: "", role: "" });
        authContext.setIsAuthenticated(false);
      } else {
        props.setMessage(message);
      }
    });
  };

  return (
    <>
      <TableRow key={props.userItem._id}>
      <TableCell
          style={{
            paddingLeft: "0px",
            paddingTop: "0px",
            color: "black",
            fontWeight:
              props.userItem._id === authContext.user._id ? "bold" : "normal",
            fontSize: "15px",
          }}
        >
          <p
            style={{ paddingTop: "16px", paddingBottom: "0px", margin: "0px" }}
          >
            {props.userItem.officeLocation}
          </p>
        </TableCell>
        <TableCell
          style={{
            paddingLeft: "0px",
            paddingTop: "0px",
            color: "black",
            fontWeight:
              props.userItem._id === authContext.user._id ? "bold" : "normal",
            fontSize: "15px",
          }}
        >
          <p
            style={{ paddingTop: "16px", paddingBottom: "0px", margin: "0px" }}
          >
            {props.userItem.username}
          </p>
        </TableCell>
        <TableCell style={{ paddingLeft: "0px", paddingTop: "0px" }}>
          <FormControl
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "35%",
              paddingTop: "16px",
            }}
          >
            <Select name="role" value={role.role} onChange={openSelect}>
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem
                disabled={props.userItem._id === authContext.user._id}
                value="user"
              >
                User
              </MenuItem>
              <MenuItem
                disabled={props.userItem._id === authContext.user._id}
                value="externaluser"
              >
                External User
              </MenuItem>
            </Select>

            {isConfirmSelect && (
              <ConfirmDialog
                content={
                  <>
                    <b>
                      Are you sure you want do change to the user{" "}
                      {props.userItem.username} from {role.role} to {selRole}?
                    </b>
                  </>
                }
                handleOk={confirmSelect}
                handleCancel={toggleSelectConfirm}
                okText="Yes"
                cancelText="No"
                isConfirmOpen={isConfirmSelect}
              />
            )}
          </FormControl>
        </TableCell>
        <TableCell style={{ paddingLeft: "0px", paddingTop: "0px" }}>
          <FormControl
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "35%",
              paddingTop: "16px",
            }}
          >
            <Select
              name="manager"
              value={role.manager}
              onChange={onChange}
              displayEmpty
            >
              <MenuItem value="" disabled>
                None set
              </MenuItem>
              {props.users.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell style={{ paddingLeft: "0px", paddingTop: "0px" }}>
          <div
            style={{
              border: role.availibility
                ? "1px solid lightgreen"
                : "1px solid red",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              backgroundColor: role.availibility ? "lightgreen" : "red",
              margin: "0px 0px 5px 30px",
              cursor: "pointer",
              marginTop: "16px",
            }}
            onClick={() => {
              setRole({ ...role, availibility: !role.availibility });
              setChanged(true);
            }}
          ></div>
        </TableCell>
        <TableCell style={{ paddingLeft: "0px" }}>
          <FormControlLabel
            control={
              <Switch
                name="active"
                color="primary"
                checked={role.active}
                onChange={() => {
                  setRole({ ...role, active: !role.active });
                  setChanged(true);
                }}
              />
            }
            label={role.active ? "Active" : "Inactive"}
          />
        </TableCell>
        <TableCell align="right" style={{ paddingRight: "0px" }}>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={{ marginRight: "10px" }}
            onClick={togglePwdChange}
          >
            Update Password
          </Button>

          {isPwdChangeOpen && (
            <AdminChangePassword
              handleCancel={togglePwdChange}
              cancelText="Cancel"
              isPwdChangeOpen={isPwdChangeOpen}
              user={props.userItem}
              submitChangePassword={submitChangePassword}
            />
          )}

          <Button
            style={{ marginRight: "10px" }}
            variant="outlined"
            color="primary"
            disabled={!changed}
            onClick={updateUser}
          >
            Update
          </Button>

          {isConfirmOpen && (
            <ConfirmDialog
              content={
                <>
                  <b>
                    Are you sure you want to delete the user{" "}
                    {props.userItem.username}?
                  </b>
                </>
              }
              handleOk={deleteConfirmedByUser}
              handleCancel={toggleConfirm}
              okText="Yes"
              cancelText="No"
              isConfirmOpen={isConfirmOpen}
            />
          )}

          <Button
            variant="contained"
            color="secondary"
            style={{ justifySelf: "flex-end" }}
            onClick={toggleConfirm}
            disabled={props.userItem._id === authContext.user._id}
          >
            Delete
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};

export default UserItem;
